import { useState} from 'react';

const Players = props =>{
    const [showPlayers, setShowPlayers] = useState(false);

    if (Object.keys(props.tableData).length === 0) {
        return <div>Loading...</div>;
    }
    
    //const statLabels= props.tableData.boxStats[1][props.type].labels;
    const boxStats = props.oppo ? props.tableData.boxStatsOppo : props.tableData.boxStats;
    const statLabels= boxStats[1][props.type].labels;

    return <div>
        <h2 className='tableHeader' onClick={() => setShowPlayers(!showPlayers)}>{props.type.charAt(0).toUpperCase() + props.type.slice(1)} Stats {props.oppo ? "" : " For "}<span style={{fontSize: '0.8em'}}>{showPlayers ? '\u25BC' : '\u25B6'}</span></h2>
        {showPlayers && <table className="playerTable">
            <thead>
                <tr>
                    <th>Week</th>
                    <th>Team</th>
                    <th>Name</th>
                    {statLabels.map((label, idx) => (
                        <th key={idx}>{label}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {Object.keys(boxStats).map( weekNum =>
                    boxStats[weekNum][props.type].players.slice(0,3).map((player, playerIdx)=>(
                        <tr key={`${weekNum}_${playerIdx}_row`}>
                            <td key={`${weekNum}_${playerIdx}_week`} className={playerIdx == 0 ? 'topRow' : ''}>{weekNum}</td>
                            <td key={`${weekNum}_${playerIdx}_team`} className={playerIdx == 0 ? 'topRow' : ''}>{boxStats[weekNum].teamLabel}</td>
                            <td key={`${weekNum}_${playerIdx}_name`} className={playerIdx == 0 ? 'topRow' : ''}>{player.athlete.displayName}</td>
                            {player.stats.map((stat, statIdx) => (
                                <td key={`${weekNum}_${playerIdx}_${statIdx}`} className={playerIdx == 0 ? 'topRow' : ''}>{stat}</td>
                            ))}
                        </tr>
                    ))
                )}
            </tbody>
        </table>}
    </div>

}

export default Players;